export default __webpack_public_path__ + "static/media/workspace-icon.44de90ab.svg";